const ASSET = "https://customer-assets-m6fa6gv7.emergentagent.net/job_729ef7a1-8e7a-4b06-b8d6-fef47e432a41/artifacts";
const ASSET2 = "https://customer-assets-jai6qajn.emergentagent.net/job_wild-journey-9/artifacts";

export const IMAGES = {
  hero: `${ASSET2}/ilooufbl__DSC3958%20%281%29.webp`,
  chaletsDusk: `${ASSET2}/ilooufbl__DSC3958%20%281%29.webp`,
  pavilionNight: `${ASSET2}/c4pw8ub4_165434186_2857282417867938_268620733862696405_n.jpg`,
  poolHut: `${ASSET2}/wijnz3jf_483836103_1042362961259728_3642561154078480341_n.jpg`,
  maskPainting: `${ASSET2}/r4etilhr_4%20%281%29.jpeg`,
  barnDining: `${ASSET2}/65r3n1s3_3.webp`,
  poolFun: `${ASSET2}/gv5fyeeh_2.JPG`,
  archery: `${ASSET2}/40uxwxey_8%20%281%29.webp`,
  shooting: `${ASSET2}/spx6h2u7_7.webp`,
  jungleAlt: "https://images.unsplash.com/photo-1582774475827-9814e8005fb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxqdW5nbGUlMjBhZHZlbnR1cmV8ZW58MHx8fHwxNzg4MTE4NTI2fDA&ixlib=rb-4.1.0&q=85",
  rafting: "https://images.unsplash.com/photo-1599443380179-33737c17ca81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHx3aGl0ZSUyMHdhdGVyJTIwcmFmdGluZ3xlbnwwfHx8fDE3ODgxMTg1MjZ8MA&ixlib=rb-4.1.0&q=85",
  zipline: "https://images.unsplash.com/photo-1651183993471-ea2391960f6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHx6aXAlMjBsaW5lJTIwZm9yZXN0fGVufDB8fHx8MTc4ODExODUyNnww&ixlib=rb-4.1.0&q=85",
  paintball: "https://images.unsplash.com/photo-1615133878310-b053dda98b04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxwYWludGJhbGwlMjBvdXRkb29yfGVufDB8fHx8MTc4ODExODUyNnww&ixlib=rb-4.1.0&q=85",
  teamBuilding: "https://images.unsplash.com/photo-1527525443983-6e60c75fff46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHx0ZWFtJTIwYnVpbGRpbmclMjBuYXR1cmV8ZW58MHx8fHwxNzg4MTE4NTI2fDA&ixlib=rb-4.1.0&q=85",
  pottery: "https://images.unsplash.com/photo-1595351298020-038700609878?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxwb3R0ZXJ5JTIwbWFraW5nfGVufDB8fHx8MTc4ODExODUyNnww&ixlib=rb-4.1.0&q=85",
  camping: "https://images.unsplash.com/photo-1595923112485-5e7c738fa67b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxjYW1waW5nJTIwbmF0dXJlJTIwbmlnaHR8ZW58MHx8fHwxNzg4MTE4NTI2fDA&ixlib=rb-4.1.0&q=85",
  battleArena: `${ASSET}/bv1euylj__DSC0036.webp`,
  raftingReal: `${ASSET}/8xrnq6x0_WhatsApp%20Image%202026-06-14%20at%2011.16.06%20AM.jpeg`,
  raftBuilding: `${ASSET}/jh13yhzq_WhatsApp%20Image%202026-06-14%20at%2012.20.18%20PM.jpeg`,
  barnSession: `${ASSET}/npecjr0l_WhatsApp%20Image%202026-06-14%20at%2012.20.20%20PM%20%282%29.jpeg`,
};

export const ZONES = [
  {
    id: "adventure",
    index: "01",
    name: "Adventure Zone",
    tagline: "Stretch every comfort zone",
    description:
      "River, rope and canopy. Purpose-built challenges that forge trust, courage and adaptability — deep inside a living rubber plantation.",
    activities: ["Rafting", "Rope Courses", "Zip-Line", "Compass March"],
    image: IMAGES.rafting,
  },
  {
    id: "battle",
    index: "02",
    name: "Battle Zone",
    tagline: "Strategy under fire",
    description:
      "High-energy tactical arenas where squads plan, execute and adapt. Precision, communication and nerve decide who walks out victorious.",
    activities: ["Gel Blaster", "Paintball", "Archery", "Target Shooting"],
    image: IMAGES.battleArena,
  },
  {
    id: "challenge",
    index: "03",
    name: "Challenge Zone",
    tagline: "Pressure makes leaders",
    description:
      "Structured simulations that surface real behaviours — strategic thinking, resilience and execution — then turn them into lasting growth.",
    activities: ["Strategic Thinking", "Leadership Trials", "Resilience Building", "Execution Drills"],
    image: IMAGES.teamBuilding,
  },
  {
    id: "build",
    index: "04",
    name: "Build Zone",
    tagline: "Minds that build together",
    description:
      "Hands-on strategic, cognitive and creative games — from raft building to problem-solving missions — engineered around team dynamics.",
    activities: ["Strategic Games", "Cognitive Games", "Creative Builds", "Problem Solving"],
    image: IMAGES.raftBuilding,
  },
  {
    id: "leisure",
    index: "05",
    name: "Leisure & Creative",
    tagline: "Slow down. Reconnect.",
    description:
      "The quieter side of the wild. Space for renewal, creativity and reflection — under the canopy, beside the fire, at your own pace.",
    activities: ["Pottery & Mask Painting", "Bird Watching", "Nirvana Yoga & Meditation", "Camping", "Pool & Barn Dining"],
    image: IMAGES.maskPainting,
  },
];

export const PROGRAMS = [
  {
    name: "TROY",
    code: "P.01",
    description:
      "High-performance team building simulations. One mission, one wall, one team — break through together or not at all.",
    tags: ["Team Performance", "Simulation"],
  },
  {
    name: "BRAVO",
    code: "P.02",
    description:
      "High-performance team building fused with the 5Cs leadership model. Build the team, then build the leaders inside it.",
    tags: ["Leadership 5Cs", "Team Building"],
  },
  {
    name: "LOST LAND",
    code: "P.03",
    description:
      "An extreme jungle survival programme. Stripped of comfort, teams rediscover instinct, grit and each other.",
    tags: ["Jungle Survival", "Extreme"],
  },
  {
    name: "BLITZKRIEG",
    code: "P.04",
    description:
      "Elite high-performance leadership simulation. Speed, strategy and decisive action under relentless pressure.",
    tags: ["Elite Leadership", "Tactical"],
  },
];

export const STAY_MODES = [
  {
    name: "Camping Mode",
    capacity: "100 Pax",
    description: "Comfortable 4–6 man tents with fans, under a canopy of stars.",
    icon: "tent",
  },
  {
    name: "Barn Mode",
    capacity: "40 Pax",
    description: "Dorm-style air-conditioned sleeping at the Mini Barn House.",
    icon: "barn",
  },
  {
    name: "Cottage Mode",
    capacity: "15 Pax",
    description: "Private air-conditioned cottage rooms for smaller groups.",
    icon: "cottage",
  },
];

export const STATS = [
  { value: "4 Acres", label: "Rubber plantation venue" },
  { value: "1,000+", label: "Trees preserved" },
  { value: "90%", label: "Upcycled design" },
  { value: "2023", label: "Best Sustainable Tourism SME" },
];

export const GALLERY = [
  { src: IMAGES.battleArena, caption: "Battle Arena — Blitzkrieg Gelblaster Squad", tall: true },
  { src: IMAGES.raftingReal, caption: "River run — Rafting the estate waters", tall: false },
  { src: IMAGES.raftBuilding, caption: "Build Zone — Raft building challenge", tall: false },
  { src: IMAGES.barnSession, caption: "The Barn — Strategy session in the wooden hall", tall: true },
  { src: IMAGES.zipline, caption: "Adventure Zone — Zip-line through the canopy", tall: false },
  { src: IMAGES.maskPainting, caption: "Leisure & Creative — Traditional mask painting", tall: false },
  { src: IMAGES.pavilionNight, caption: "Nights at the Barn — the glowing pavilion", tall: true },
  { src: IMAGES.poolHut, caption: "The natural pool — reflections of the estate", tall: false },
  { src: IMAGES.barnDining, caption: "Barn dining — chef-hosted meals in the wild", tall: true },
  { src: IMAGES.poolFun, caption: "Poolside — slow afternoons by the water", tall: false },
  { src: IMAGES.archery, caption: "Battle Zone — Archery in the rubber woods", tall: false },
  { src: IMAGES.shooting, caption: "Battle Zone — Target shooting practice", tall: true },
];

export const CONSULTANTS = [
  {
    name: "Prof. Kasun I. Wijetilleke, Ph.D.",
    role: "C-Suite Executive · Board Director · Corporate Strategist & Clinical Psychologist",
    photo: "/panel/kasun.jpg",
    short: "C-suite leader, board director and academic with two decades across corporate governance, global business strategy and behavioral science.",
    more: {
      bio: [
        "A distinguished C-suite leader, board director and academic with over two decades of transformative experience spanning corporate governance, global business strategy and behavioral science. As Independent Board Director at People's Insurance PLC, his strategic oversight helped steer the firm to become Sri Lanka's most profitable listed general insurer in 2023 — sustaining that market leadership to date.",
        "His commercial career began at British American Tobacco (Ceylon Tobacco Company) and progressed into senior leadership roles at Unilever Sri Lanka, Mindshare Global and MAS Active, driving international marketing initiatives and operational turnarounds.",
      ],
      highlights: [
        "2 Ph.D.s and 4 Master's degrees, including 2 MBAs from the UK",
        "Life Fellow — Chartered Professional Managers of Sri Lanka (FCPM) · Fellow — Chartered Institute of Marketing (UK)",
        "Consultant to University of Sri Jayewardenepura, Sri Lanka Police Academy, Sri Lanka Navy, Institute of Psychological Studies",
        "Member — APA, ACA, CCPA, Sri Lanka Institute of Directors (SLID)",
        "International Icon Excellence Award 2026 · TOYP Sri Lanka · Honors from Lions Clubs & Toastmasters International",
      ],
    },
  },
  {
    name: "Dr. Bradley Emerson",
    role: "Specialized Leadership Coach · Founder, Business Athletes",
    photo: "/panel/bradley.jpg",
    short: "Leadership coach, keynote speaker, podcaster and author with four decades across banking, education and strategic leadership.",
    more: {
      bio: [
        "Founder & CEO of Business Athletes Pvt. Ltd., a Colombo-based consultancy focused on executive coaching, leadership development and talent building. Over four decades of experience spanning banking, education and public-sector reform.",
        "Former Deputy CEO of Pan Asia Bank, where he was instrumental in the bank's rebranding and turnaround, with earlier leadership roles at Commercial Bank, Nations Trust Bank and Bank of Oman, Bahrain & Kuwait. Served as Executive Director of the Imperial Institute of Higher Education (IIHE) and Director/COO of the PPP Unit at the Ministry of Finance.",
      ],
      highlights: [
        "MBA in International Marketing (University of Sri Jayewardenepura) · DBA scholar",
        "Fellow of the Institute of Bankers (FIB) · Advanced Diploma in Management Accounting, CIMA (UK)",
        "Non-Executive Director — People's Bank, People's Leasing & Finance PLC, Atarah Capital",
        "Certified Systemic Team Coach · Executive Coach of the Year 2023",
      ],
    },
  },
  {
    name: "Ms. Nora Imeli",
    role: "Personal Development Coach",
    photo: "/panel/nora.jpg",
    short: "Hungarian-born life coach helping individuals break through mental roadblocks and live with purpose and confidence.",
    more: {
      bio: [
        "Nora is dedicated to helping individuals achieve personal growth and transformation. Her passion for understanding the human mind and behavior drives her intuitive, empowering approach — supporting people in self-discovery, resilience and unlocking their full potential.",
        "With a background in high-pressure corporate environments, she provides practical guidance to help clients break through mental and emotional roadblocks, inspired by the profound impact personal growth had on her own life.",
      ],
      highlights: [
        "Diploma in Higher Education in Psychology",
        "BSc Honours in Psychology — The Open University, UK (in progress)",
        "Qualified Rapid Transformational Therapy (RTT) Practitioner",
        "Certified Life Coach — International Association of Professions Career College",
      ],
    },
  },
  {
    name: "Pritha Dubey",
    role: "International Master Trainer",
    photo: "/panel/pritha.jpg",
    short: "Transformative coach and former Forbes coach; sales success coach, suit coach and trainer, IFC trainer. Founder of Success Vitamins India.",
  },
  {
    name: "Mimi Nicklin",
    role: "International Bestselling Author",
    photo: "/panel/mimi.jpg",
    short: "Award-winning founder of the world's widest-reaching organizational empathy platform. Keynote speaker and international leadership trainer.",
  },
  {
    name: "D. Lankathilake",
    role: "International Master Trainer",
    photo: "/panel/lankathilake.jpg",
    short: "Certified Master Coach, talent specialist, personality coach, competency mapper and L&D consultant.",
  },
  {
    name: "Puneet Rathi",
    role: "Executive Director",
    photo: "/panel/puneet.jpg",
    short: "Seasoned HR leader and leadership consultant with 23+ years across India and West Asia — strategic HR, CXO-level assessments and business performance improvement.",
  },
  {
    name: "Akansha Arora",
    role: "Academic Board Director",
    photo: "/panel/akansha.jpg",
    short: "Leadership coach and facilitator with 23+ years in training and consulting across South Asia. MBA and Master in Psychology (INSEAD); certified in MBTI, Hogan, FIRO-B and Caliper.",
  },
  {
    name: "Shiv Tandon",
    role: "Academic Board Director",
    photo: "/panel/shiv.jpg",
    short: "Creative entrepreneur, educator and storyteller based in India and Singapore. NUS graduate in Industrial & Systems Engineering; formed Head of Creative Content at Embibe; award-winning writer/director.",
  },
  {
    name: "Sandeep Khurana",
    role: "Academic Board Director",
    photo: "/panel/sandeep.jpg",
    short: "Applied AI practitioner, researcher and academic with three decades in Data Science, Generative AI and Sustainability across India and the US. Adjunct Faculty at IIM Udaipur; founder of QuantLeap Consulting.",
  },
];


export const CONTACTS = [
  { label: "077 626 7115", wa: "https://wa.me/94776267115" },
  { label: "070 393 1955", wa: "https://wa.me/94703931955" },
  { label: "076 528 7449", wa: "https://wa.me/94765287449" },
];

export const MARQUEE_ITEMS = [
  "Leading",
  "Uniting",
  "Stretching Horizons",
  "Rafting",
  "Gel Blaster",
  "Zip-Line",
  "Camping",
  "Team Building",
];
